import { render, staticRenderFns } from "./navEdit.vue?vue&type=template&id=af8a321e&scoped=true&"
import script from "./navEdit.vue?vue&type=script&lang=js&"
export * from "./navEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8a321e",
  null
  
)

export default component.exports